import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComponentRoutesEnum } from '@shared/utils/component-routes';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '@shared/services/navigation-service/navigation.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'eqb-fe-onboarding-app';

	constructor(
		private translate: TranslateService,
		private router: Router,
		private navigationService: NavigationService
	) {
		// this language will be used as a fallback when a translation isn't found in the current language
		this.translate.setDefaultLang('en');

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		this.translate.use('en');
	}

	public hideHeader(): boolean {
		return (
			this.router.url ===  `/${ComponentRoutesEnum.MARKETING}`
		);
	}

	public hideFooter(): boolean {
		return (
			this.router.url === `/${ComponentRoutesEnum.MARKETING}`
		);
	}

	

	/**
	 * Checks if the margin auto should be removed depending on the template displayed
	 * @returns boolean
	 */
	public addMarginAuto(): boolean {
		return this.router.url !== `/${ComponentRoutesEnum.LOGIN}`;
	}

	ngOnInit() {
		this.navigationService.initializeEventListeners();
	}

	ngOnDestroy() {
		this.navigationService.cleanupEventListeners();
	}
}
